import React from "react";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";
import Dropzone from "react-dropzone";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from '@mui/material/FormControl';
import { Trans, withTranslation } from "react-i18next";

import UserBar from "../components/UserBar";
import axios from "../components/Axios";
import "./Upload.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      folders: [],
      state: "upload", //upload, name, uploading
      file: {},
      subtitle: null,
      name: "",
      duration: 0,
      credit: 0,
      folder: '',
      language: 'auto',
      notify: false,
      notify_type: 'email',
      multi_language: false,
      //asr_version: 'large-v3',
      dev_params: '{"asr_version": "large-v3"}',
      email: '',
      sms: '',
      features: ['Actions', 'Logos', 'Nudity', 'Speech'],
      size: 0,
      progress: 0,
    };
    this.dropzoneRef = React.createRef();
    this.onDrop = this.onDrop.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.onUploadProgress = this.onUploadProgress.bind(this);
    this.onSubtitle = this.onSubtitle.bind(this);
  }

  componentDidMount() {
    let u = localStorage.getItem("user_id");
    if (u === null) {
      this.props.history.push("/login");
      return;
    }

    let user = JSON.parse(localStorage.getItem("user"));
    this.setState({ email: user.email });

    //load dev params
    let dev_params = localStorage.getItem("dev_params");
    if(dev_params!=null){
      this.setState({ dev_params: dev_params });
    }

    axios
      .get("/user/" + u + "/video_projects", { params: { folder: '/' } })
      .then(
        function (response) {
          this.setState({
            folders: response.data.folders,
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
        }.bind(this)
      );

    axios
      .get('/user/stripe/payment_methods')
      .then(
        function (response) {
          this.setState({
            credit: response.data.credit,
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
        }.bind(this)
      );
  }

  handleChange(e) {
    let value = e.target.value;
    if (e.target.type === 'checkbox') {
      value = e.target.checked;
    }

    this.setState({ [e.target.name]: value });
  }

  openDialog() {
    this.dropzoneRef.current.open();
  }

  onDrop(e) {
    this.setState({
      state: "name",
      file: e[0],
      name: e[0].name.replace(/\.(mp4|m4v|mov|mkv|avi|webm|mpe?g|wmv|flv|mxf|ts|3gp)$/i, "") || e[0].name, // without the file extension
      size: e[0].size,
    });

    let video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = function () {
      window.URL.revokeObjectURL(video.src);
      this.setState({ duration: video.duration });
    }.bind(this);
    video.src = URL.createObjectURL(e[0]);
  }

  onSubtitle(e){
    this.setState({ subtitle: e.target.files[0] });
  }

  onUploadProgress(e) {
    this.setState({ progress: e.loaded });
  }

  uploadFile(e) {
    let p;
    var formData = new FormData();
    try{
      p = JSON.parse(this.state.dev_params);
    }catch(e){
      alert(e)
      return
    }

    for ( var key in p ) {
        formData.append(key, p[key]);
    }
    formData.append("user_id", localStorage.getItem("user_id"));
    formData.append("project_name", this.state.name);
    formData.append("video_file", this.state.file);
    formData.append("folder", this.state.folder);
    formData.append("language", this.state.language);
    formData.append("notify", this.state.notify);
    formData.append("notify_type", this.state.notify_type);
    formData.append("multi_language", this.state.multi_language);
    //formData.append("asr_version", this.state.asr_version);
    formData.append("email", this.state.email);
    formData.append("sms", this.state.sms);
    formData.append("features", this.state.features);
    formData.append("subtitles", this.state.subtitle);

    //return

    axios
      .post("/video_project", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: this.onUploadProgress,
      })
      .then(
        function (response) {
          localStorage.setItem("dev_params", this.state.dev_params) //save dev params
          this.props.history.push("/");
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          if (error.response.status === 400) {
            alert(error.response.data.message);
            this.setState({ state: "upload" });
          }
          //this.setState({ loading: false });
        }.bind(this)
      );

    this.setState({ state: "uploading" });
  }

  formatSize(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    let k = 1024;
    let dm = decimals < 0 ? 0 : decimals;
    let sizes = ["Bytes", "KB", "MB", "GB"];
    let i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  formatDuration(s) {
    if (Number.isNaN(s)) return "?";
    if (s === 0) return "?";

    let pad = function (num, size) {
      return ("000" + num).slice(size * -1);
    },
      time = parseFloat(s).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60);
    if (hours > 0) return hours + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
    else return minutes + ":" + pad(seconds, 2);
  }

  render() {
    return (<>
      <UserBar title=""></UserBar>
      <Dropzone
        ref={this.dropzoneRef}
        onDropAccepted={this.onDrop}
        accept={"video/*,.mkv"}
        maxSize={5368706371}
        noClick
      >
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div
            {...getRootProps({
              className:
                "dropzone" + (this.state.state !== "upload" ? " hidden" : ""),
            })}
            style={{ boxShadow: isDragActive ? "inset 0 0 0 3px #1355B2" : "none", backgroundColor: isDragActive ? "rgba(0, 123, 255, 0.1)" : "transparent" }}
          >
            <input {...getInputProps()} />
            <div style={{ height: "160px" }}></div>
            <img alt="" src="/img/upload.png" style={{ height: "133px" }} />
            <div className="upload-title">
              <Trans>Drag and drop anywhere to upload</Trans>
            </div>
            <div className="upload-subtitle">
              <Trans>Maximum file size</Trans> : 5 GB | <Trans>Supported formats</Trans> : .mov, .mp4, .avi,
              .mkv
            </div>
            <Button
              style={{ marginTop: "32px" }}
              className="Button ButtonPrimary"
              endIcon={<CloudUploadIcon />}
              onClick={this.openDialog}
            >
              <Trans>or choose a file</Trans>
            </Button>
          </div>
        )}
      </Dropzone>
      {this.state.state !== "upload" && (
        <div>
          <Container maxWidth="xs" style={{ marginTop: "100px" }}>
            <div className="uploadProgressBox">
              <CircularProgress
                size={160}
                thickness={7}
                className="uploadProgress"
                variant="determinate"
                value={(this.state.progress / this.state.size) * 100}
              />
              <div className="uploadProgressNumber">
                {Math.round((this.state.progress / this.state.size) * 100)}%
              </div>
              <div className="uploadProgressText">
                {(this.state.state === "name" ? <Trans>Preparing to upload</Trans> : <Trans>Uploading</Trans>)}
              </div>
            </div>
            <div
              className="upload-subtitle text-center"
              style={{ margin: "8px 0 24px" }}
            >
              {this.state.file.name} | {this.formatDuration(this.state.duration)} | {this.formatSize(this.state.progress)}{" "}
              of {this.formatSize(this.state.size)}
            </div>
            {this.state.state === "name" && (
              <>
                <TextField
                  value={this.state.name}
                  name="name"
                  label={<Trans>Name</Trans>}
                  variant="outlined"
                  fullWidth
                  className="uploadField"
                  onChange={this.handleChange}
                  style={{ marginBottom: '16px' }}
                />
                <Autocomplete
                  options={this.state.folders} freeSolo
                  getOptionLabel={(option) => option}
                  value={this.state.folder} className="uploadField" fullWidth size="small"
                  onInputChange={(e, v) => { this.setState({ folder: v }) }}
                  renderInput={(params) => <TextField {...params} variant="outlined" name="folder" label={<Trans>Folder</Trans>} />}
                  style={{ marginBottom: '16px' }}
                />
                <div className="flex-row" style={{ alignItems: "baseline" }}>
                  <Button variant="outlined" component="label" style={{flexShrink: 0, marginRight: '8px', marginBottom: '16px'}}>
                    <Trans>Subtitle File</Trans> 
                    <input
                      hidden
                      type="file"
                      accept=".srt"
                      onChange={this.onSubtitle}
                    />
                  </Button>
                  <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {(this.state.subtitle ? `${this.state.subtitle.name}` : '')}
                  </div>
                </div>
                <div className="flex-row" style={{ alignItems: "flex-start" }}>
                  <TextField select
                    value={this.state.language}
                    name="language"
                    label={<Trans>Desired Transcript Language</Trans>}
                    variant="outlined"
                    fullWidth
                    className="uploadField"
                    onChange={this.handleChange}
                    style={{ marginBottom: '16px', flex: '1' }}
                  >
                    <MenuItem value="auto"><Trans>Auto Detect</Trans></MenuItem>
                    <MenuItem value="en"><Trans>English</Trans></MenuItem>
                    <MenuItem value="fr"><Trans>French</Trans></MenuItem>
                    <MenuItem value="es"><Trans>Spanish</Trans></MenuItem>
                    <MenuItem value="de"><Trans>German</Trans></MenuItem>
                  </TextField>
                  <FormControlLabel
                    control={<Checkbox checked={this.state.multi_language} onChange={this.handleChange} name="multi_language" color="primary" />}
                    label={<Trans>Multi Language</Trans>} style={{ margin: "0 0 0 8px" }}
                  />
                </div>
                <TextField
                  hidden={!process.env.REACT_APP_ENV.startsWith('dev')}
                  label="Dev Parameters" name="dev_params"
                  multiline
                  variant="outlined"
                  fullWidth
                  className="uploadField"
                  value={this.state.dev_params}
                  onChange={this.handleChange}
                  style={{ marginBottom: '16px'}}
                />
                <Autocomplete
                  multiple size="small" className="uploadField" disableCloseOnSelect
                  options={['Actions', 'Logos', 'Nudity', 'Speech']}
                  value={this.state.features}
                  getOptionLabel={(option) => option}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option}
                      </li>
                    );
                  }}
                  onChange={(e, v) => { this.setState({ features: v }) }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined"
                      label={<Trans>Deselect features for faster processing time</Trans>} placeholder="" />
                  )}
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.notify} onChange={this.handleChange} name="notify" color="primary" />}
                  label={<Trans>Notify me when done processing</Trans>}
                />
                <div className="flex" hidden={!this.state.notify}>
                  <FormControl>
                    <Select
                      value={this.state.notify_type} name="notify_type" id="notify_type"
                      variant="outlined"
                      className="conditionField"
                      style={{ flex: "0", borderRadius: '4px' }}
                      onChange={this.handleChange}
                    >
                      <MenuItem value={'email'}>Email</MenuItem>
                      <MenuItem value={'sms'}>SMS</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    value={this.state.email}
                    name="email" type="email"
                    label="Email"
                    variant="outlined"
                    className="uploadField"
                    style={{ flex: "1" }} onChange={this.handleChange}
                    hidden={this.state.notify_type === 'sms'}
                    slotProps={{
                      inputLabel: { shrink: true }
                    }}
                  />
                  <TextField
                    value={this.state.sms}
                    name="sms" type="tel"
                    label="Phone Number (International Format)"
                    variant="outlined"
                    className="uploadField"
                    style={{ flex: "1" }} onChange={this.handleChange}
                    hidden={this.state.notify_type === 'email'}
                    slotProps={{
                      inputLabel: { shrink: true }
                    }}
                  />
                </div>
                <div>
                  <div className="upload-subtitle" hidden={this.state.duration / 3600 > this.state.credit}><Trans>Credits remaining after upload</Trans>: <span title={this.state.credit + ' - ' + (this.state.duration / 3600).toFixed(1)}>{(this.state.credit - this.state.duration / 3600).toFixed(1)}</span></div>
                  <div className="upload-subtitle" hidden={this.state.duration / 3600 <= this.state.credit}>
                    <b style={{ color: 'rgb(220, 0, 78)' }}><Trans>Insufficient credit</Trans></b>: <Trans>Please</Trans> <a href='/account/billing' target="_blank"><Trans>add credit</Trans></a> <Trans>and</Trans> <a href="#"><Trans>refresh</Trans></a>.
                  </div>
                </div>
                <Button
                  style={{ margin: "16px auto", display: "block" }}
                  className="Button ButtonPrimary"
                  onClick={this.uploadFile} disabled={this.state.duration / 3600 > this.state.credit}
                >
                  <Trans>Save & Upload</Trans>
                </Button>
              </>
            )}
            {this.state.state === "uploading" && (
              <>
                <div className="upload-title">
                  <Trans>Your video is being processed</Trans>
                </div>
                <div className="upload-subtitle">
                  <Trans>When your upload is complete, we'll start parsing your file. Once that magical technological process is completed, your video will appear in your library.</Trans> <br />
                  <br />
                  <Trans>Need help? If you are having trouble uploading, or you suspect that your upload has failed, please check your internet connection, make sure your video meets our compression guidlines, and the try uploading again.</Trans>

                </div>
              </>
            )}
          </Container>
        </div>
      )}
    </>);
  }
}

export default withTranslation()(Index);
